import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const itemHelpers = createMultiStyleConfigHelpers(['container', 'item']);

const SegmentedControlTheme = itemHelpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      backgroundColor: 'neutral.95',
      borderRadius: '8',
      display: 'flex',
      gap: '4',
      padding: '4',
      width: '100%',
    },
    item: {
      _checked: {
        _hover: {
          _disabled: {
            backgroundColor: 'neutral.100',
            borderColor: 'separator.primary',
          },
          backgroundColor: 'neutral.100',
          borderColor: 'separator.primary',
        },
        backgroundColor: 'neutral.100',
        borderColor: 'separator.primary',
        color: 'purple.10',
      },
      _disabled: {
        color: 'neutral.70',
        cursor: 'not-allowed',
      },
      _focus: {
        boxShadow: 'outline',
      },
      _hover: {
        _disabled: {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          color: 'neutral.70',
        },
        backgroundColor: 'neutral.93',
        borderColor: 'neutral.93',
        color: 'neutral.10',
      },
      border: '1px solid',
      borderColor: 'transparent',
      borderRadius: '4',
      color: 'neutral.40',
      cursor: 'pointer',
      flexGrow: 1,
      fontSize: '3',
      fontWeight: 'semibold',
      lineHeight: '2.375rem',
      paddingX: '0.375rem',
      textAlign: 'center',
    },
  },
});

export default SegmentedControlTheme;
